export const imagePaths = {
	analysis1: {
		ja: '@/../../images/load-analysis-map.jpg',
		en: '@/../../images/load-analysis-map_en.jpg',
		de: '@/../../images/load-analysis-map_en.jpg',
	},
	analysis2: {
		ja: '@/../../images/load-analysis-figure.jpg',
		en: '@/../../images/load-analysis-figure.jpg',
		de: '@/../../images/load-analysis-figure.jpg',
	},
	analysis3: {
		ja: '@/../../images/load-analysis-table.jpg',
		en: '@/../../images/load-analysis-table_en.jpg',
		de: '@/../../images/load-analysis-table_en.jpg',
	},
	remain1: {
		ja: '@/../../images/graph-oil.jpg',
		en: '@/../../images/graph-oil-en.jpg',
		de: '@/../../images/graph-oil-en.jpg',
	},
	remain1g: {
		ja: '@/../../images/graph-oil-gray.jpg',
		en: '@/../../images/graph-oil-gray-en.jpg',
		de: '@/../../images/graph-oil-gray-en.jpg',
	},
	remain2: {
		ja: '@/../../images/graph-gears-bearings.jpg',
		en: '@/../../images/graph-gears-bearings-en.jpg',
		de: '@/../../images/graph-gears-bearings-en.jpg',
	},
	remain2g: {
		ja: '@/../../images/graph-gears-bearings-gray.jpg',
		en: '@/../../images/graph-gears-bearings-gray-en.jpg',
		de: '@/../../images/graph-gears-bearings-gray-en.jpg',
	},
	remain3: {
		ja: '@/../../images/graph-e-brake.jpg',
		en: '@/../../images/graph-e-brake-en.jpg',
		de: '@/../../images/graph-e-brake-en.jpg',
	},
	remain3g: {
		ja: '@/../../images/graph-e-brake-gray.jpg',
		en: '@/../../images/graph-e-brake-gray-en.jpg',
		de: '@/../../images/graph-e-brake-gray-en.jpg',
	},
}
